import { CommonModule } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from "@angular/forms";
import { NgbAlertModule } from "@ng-bootstrap/ng-bootstrap";
import {
  matchPasswords,
  strongPasswordValidator,
} from "src/app/core/helpers/password.validator";
import { User } from "src/app/core/models/auth.models";
import { AuthService } from "src/app/core/services/auth/auth.service";
import { SharedModule } from "src/app/shared/shared.module";

@Component({
  selector: "app-my-profile",
  standalone: true,
  imports: [SharedModule, CommonModule, NgbAlertModule, ReactiveFormsModule],
  templateUrl: "./my-profile.component.html",
  styleUrl: "./my-profile.component.scss",
})
export class MyProfileComponent implements OnInit {
  breadCrumbItems!: Array<{}>;
  defaultAvatarName = "";
  changePasswordForm!: FormGroup;
  currentUser: User = {
    userId: 0,
    name: "",
    email: "",
    token: "",
    permissions: "",
    tenantId: "",
  };

  constructor(
    private authService: AuthService,
    private fb: FormBuilder,
  ) {
    this.currentUser = authService.currentUserValue;
    const names = this.currentUser?.name?.split(" ");
    this.defaultAvatarName = names[0]?.charAt(0) + names[1]?.charAt(0);
  }

  ngOnInit(): void {
    this.breadCrumbItems = [
      { label: "Dashboard" },
      { label: "Pefil", active: true },
    ];
    this.initForm();
  }

  initForm(): void {
    this.changePasswordForm = this.fb.group(
      {
        senhaAtual: ["", Validators.required],
        novaSenha: ["", [Validators.required, strongPasswordValidator()]],
        confirmarNovaSenha: ["", Validators.required],
      },
      {
        validators: matchPasswords,
      },
    );
  }

  onSubmit() {
    if (this.changePasswordForm.valid) {
    }
  }
}
